module.exports = __webpack_public_path__ + "static/img/3.a99024f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/canoa-quebrada/3.jpg
// module id = 3Cj9
// module chunks = 1